import { render, staticRenderFns } from "./LensImagingViz.vue?vue&type=template&id=37b1ae1e&scoped=true"
import script from "./LensImagingViz.vue?vue&type=script&lang=js"
export * from "./LensImagingViz.vue?vue&type=script&lang=js"
import style0 from "./LensImagingViz.vue?vue&type=style&index=0&id=37b1ae1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b1ae1e",
  null
  
)

export default component.exports